/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_MediaInputs */

const en_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Media`)
};

const fr_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médias OCR`)
};

const de_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Medien`)
};

const it_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Media`)
};

const ru_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Media`)
};

const es_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios OCR`)
};

const zh_cn2_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR 媒体`)
};

const ja_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCRメディア`)
};

const hi_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर मीडिया`)
};

const pt_pt2_ocr_media = /** @type {(inputs: Ocr_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia OCR`)
};

/**
* | output |
* | --- |
* | "OCR Media" |
*
* @param {Ocr_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_media = /** @type {((inputs?: Ocr_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_media(inputs)
	if (locale === "de") return de_ocr_media(inputs)
	if (locale === "it") return it_ocr_media(inputs)
	if (locale === "ru") return ru_ocr_media(inputs)
	if (locale === "es") return es_ocr_media(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_media(inputs)
	if (locale === "ja") return ja_ocr_media(inputs)
	if (locale === "hi") return hi_ocr_media(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_media(inputs)
	return en_ocr_media(inputs)
});